import React from 'react'
import { Route } from 'react-router-dom'
import AuthContainer from './AuthContainer'

const PrivateRoute = ({ component: Component, ...rest }) => {
    return (
        <AuthContainer>
            <Route {...rest} render={props => (<Component {...props} />)} />
        </AuthContainer>
    )
}

export default PrivateRoute



// WEBPACK FOOTER //
// ./resources/js/layout/PrivateRoute.js